<template>
  <!-- Sin `scrollable`: el scroll va en la lista, no en la caja, para que el pie con el
       desplegable y el boton de asignar sigan visibles al bajar. Igual que el modal de
       materias primas sin etiqueta, del que sale este. -->
  <modal :name="nombreModal" :adaptive="true" height="auto" width="780px">
    <div class="rev">
      <div class="modal-header rev-cabecera">
        <h4>{{ $t("productosSinCategoriaTitulo") }}</h4>
        <p>{{ $t("productosSinCategoriaAyuda") }}</p>
      </div>

      <div class="modal-body rev-cuerpo">
        <div class="rev-barra">
          <input
            type="search"
            class="form-control rev-buscador"
            v-model="busqueda"
            :placeholder="$t('buscarProducto')"
          />

          <div class="rev-seleccion">
            <button type="button" class="rev-enlace" @click="seleccionarTodos()">
              {{ $t("seleccionarTodas") }}
            </button>
            <span class="rev-sep">·</span>
            <button type="button" class="rev-enlace" @click="seleccionarNinguno()">
              {{ $t("seleccionarNinguna") }}
            </button>
          </div>
        </div>

        <p class="rev-aviso" v-if="truncado">
          {{ $tc("revisarTruncado", tope, { n: tope, total: total }) }}
        </p>

        <div class="rev-lista" v-if="visibles.length">
          <label
            v-for="prod in visibles"
            :key="'p' + prod.code"
            class="rev-fila"
            :class="{ puesta: !!marcados[prod.code] }"
          >
            <input
              type="checkbox"
              :checked="!!marcados[prod.code]"
              @change="marcar(prod.code, $event.target.checked)"
            />
            <span class="rev-nombre">{{ prod.nombre || $t("productoSinNombre") }}</span>
            <!-- En cuantos terminales esta. Cuando no son todos, o el producto no llego a
                 alguno o hay dos productos distintos que se llaman igual, y eso conviene
                 verlo antes de meterlos a los dos en la misma categoria. -->
            <span class="rev-actual" :class="{ vacia: prod.terminales < terminales }">
              {{ $tc("enNTerminales", prod.terminales, { n: prod.terminales, t: terminales }) }}
            </span>
          </label>
        </div>

        <p class="rev-vacio" v-else-if="cargado">{{ $t("sinProductosSinCategoria") }}</p>

        <p class="rev-error" v-if="error">{{ error }}</p>
      </div>

      <div class="modal-footer rev-pie">
        <div class="rev-destino">
          <label for="revCatDestino">{{ $t("asignarEstaCategoria") }}</label>

          <!-- El mismo `el-select` filtrable que el resto de la pantalla, agrupado por
               grupo, que es el idioma del usuario: aqui no se habla de teclas. -->
          <el-select
            id="revCatDestino"
            class="select-default rev-select"
            popper-class="rev-cat-desplegable"
            v-model="codeDestino"
            filterable
            clearable
            :placeholder="$t('elegirCategoriaDestino')"
            :no-match-text="$t('sinResultadosCategoria')"
          >
            <el-option-group
              v-for="g in destinoPorGrupo"
              :key="'g' + g.grupo"
              :label="g.grupo ? $t('grupoNumero', { g: g.grupo }) : $t('fueraDeLosGrupos')"
            >
              <el-option
                v-for="c in g.categorias"
                :key="'d' + c.code"
                :value="c.code"
                :label="c.nombre"
              >
                <span class="op-nombre">{{ c.nombre }}</span>
                <span class="op-num">{{ c.productos }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>

        <div class="rev-botones">
          <button type="button" class="btn btn-claro" :disabled="guardando" @click="cerrar()">
            {{ $t("cerrar") }}
          </button>
          <button
            type="button"
            class="btn btn-verde"
            :disabled="guardando || !cuantosMarcados || !hayDestino"
            @click="asignar()"
          >
            {{ $tc("asignarACuantas", cuantosMarcados, { n: cuantosMarcados }) }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { Select, Option, OptionGroup } from "element-ui";

/**
 * Los productos que estan en una ranura sin nombre, para meterlos en una categoria.
 *
 * La pantalla decia "14 productos no estan en ninguna categoria" y ahi se acababa: para
 * colocarlos habia que salir al listado de productos y editarlos uno a uno. Esto los
 * lista y los recoloca en bloque sin moverse de sitio. Sale del modal de materias primas
 * sin etiqueta, que resuelve el mismo problema en la pantalla de etiquetas.
 *
 * Los productos vienen agrupados por `products.code`, que es su identidad DENTRO del
 * negocio: la misma carta esta en todos los terminales y cada uno tiene su fila. Por eso
 * se marca un producto, no una fila, y al asignar se escribe en todos los terminales
 * resolviendo en cada uno SU idCategory.
 *
 * Este modal SI escribe, como el de materias primas: la accion es el propio listado, y
 * separar el guardado obligaria a subir a la pantalla un estado que solo se usa aqui.
 */
export default {
  name: "ProductosSinCategoriaModal",

  props: {
    nombreModal: { type: String, default: "modalProductosSinCategoria" },
    idBusiness: { type: [String, Number], required: true },
    // Todas las categorias del negocio, tal como las devuelve getBusinessCategories.
    categorias: { type: Array, default: () => [] },
    // Terminales vivos, para decir en cuantos de ellos esta cada producto.
    terminales: { type: Number, default: 0 }
  },

  data() {
    return {
      grupo: 0,
      productos: [],
      marcados: {},
      // Contra null, no con un truthy: el code "0" es una categoria valida.
      codeDestino: null,
      busqueda: "",
      total: 0,
      tope: 500,
      truncado: false,
      cargado: false,
      cargando: false,
      guardando: false,
      error: ""
    };
  },

  computed: {
    /**
     * Las categorias con nombre, agrupadas por grupo. Una ranura sin nombre no es un
     * destino: mandarlos ahi seria dejarlos igual que estan.
     */
    destinoPorGrupo() {
      let porGrupo = {};

      this.categorias.forEach(function(c) {
        // Las que el servidor no tiene no valen de destino: se crearian en el. La API
        // lo rechaza igual.
        if (!c.nombre || (c.soloEn && c.soloEn.length)) {
          return;
        }

        let g = c.grupo || 0;

        if (!porGrupo[g]) {
          porGrupo[g] = { grupo: g, categorias: [] };
        }

        porGrupo[g].categorias.push(c);
      });

      return Object.keys(porGrupo)
        .sort(function(a, b) {
          if (Number(a) === 0) return 1;
          if (Number(b) === 0) return -1;
          return Number(a) - Number(b);
        })
        .map(function(g) {
          return porGrupo[g];
        });
    },

    hayDestino() {
      return this.codeDestino !== null && this.codeDestino !== undefined && this.codeDestino !== "";
    },

    visibles() {
      let texto = this.normalizar(this.busqueda);

      if (!texto) {
        return this.productos;
      }

      let vm = this;

      return this.productos.filter(function(p) {
        return vm.normalizar(p.nombre).indexOf(texto) !== -1;
      });
    },

    codesMarcados() {
      let vm = this;

      return Object.keys(this.marcados).filter(function(code) {
        return vm.marcados[code];
      });
    },

    cuantosMarcados() {
      return this.codesMarcados.length;
    }
  },

  methods: {
    /**
     * @param {number} grupo 1-4 para ver solo los de ese grupo, o 0 para todo el negocio.
     */
    abrir(grupo) {
      this.grupo = grupo || 0;
      this.productos = [];
      this.marcados = {};
      this.codeDestino = null;
      this.busqueda = "";
      this.total = 0;
      this.truncado = false;
      this.cargado = false;
      this.error = "";

      this.$modal.show(this.nombreModal);
      this.cargar();
    },

    cerrar() {
      this.$modal.hide(this.nombreModal);
    },

    mostrarError(mensaje) {
      this.error = mensaje || this.$t("errorInesperado");
    },

    cargar() {
      if (this.cargando) {
        return;
      }

      this.cargando = true;

      var config = {
        params: {
          idBusiness: this.idBusiness,
          grupo: this.grupo,
          jwt: this.$store.getters.jwt
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "businessCategories/getProductosSinCategoria", config)
        .then(function(response) {
          vm.cargando = false;

          if (!response.data.response) {
            vm.mostrarError(response.data.message);
            return;
          }

          vm.productos = response.data.result.productos;
          vm.total = response.data.result.total;
          vm.tope = response.data.result.tope;
          vm.truncado = response.data.result.truncado;
          vm.cargado = true;
        })
        .catch(function(error) {
          vm.cargando = false;
          vm.mostrarError(vm.$t("errorInesperado"));
          console.log(error);
        });
    },

    /** Minusculas y sin tildes, igual que en el resto del panel. */
    normalizar(texto) {
      return (texto || "")
        .toString()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase()
        .trim();
    },

    // Vue 2 no ve las claves nuevas de un objeto, de ahi el $set.
    marcar(code, puesto) {
      this.$set(this.marcados, code, !!puesto);
    },

    seleccionarTodos() {
      let vm = this;

      this.visibles.forEach(function(p) {
        vm.$set(vm.marcados, p.code, true);
      });
    },

    seleccionarNinguno() {
      this.marcados = {};
    },

    asignar() {
      if (this.guardando || !this.cuantosMarcados || !this.hayDestino) {
        return;
      }

      this.guardando = true;
      this.error = "";

      var config = {
        params: { jwt: this.$store.getters.jwt },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt }
      };
      var params = {
        idBusiness: this.idBusiness,
        codes: this.codesMarcados,
        codeDestino: this.codeDestino,
        jwt: this.$store.getters.jwt
      };

      let vm = this;

      this.axios
        .post(this.$store.getters.apiUrl + "businessCategories/asignarCategoriaAProductos", params, config)
        .then(function(response) {
          vm.guardando = false;

          if (!response.data.response) {
            vm.mostrarError(response.data.message);
            return;
          }

          // La pantalla recarga y se entera de cuantos quedan; el modal se queda abierto
          // y recarga su lista, porque lo normal es colocar unos cuantos y seguir.
          vm.$emit("asignados", response.data.result);
          vm.marcados = {};
          vm.codeDestino = null;
          vm.cargar();
        })
        .catch(function(error) {
          vm.guardando = false;
          vm.mostrarError(vm.$t("errorInesperado"));
          console.log(error);
        });
    }
  },

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup
  }
};
</script>

<style scoped>
/* El lenguaje visual es el compartido: cabecera, barra, lista, avisos y pie salen
   de ahi. Aqui solo lo que es de ESTE modal. */
@import "../revisar-en-bloque.css";

/* Los nombres de producto pueden ser largos y la fila no debe crecer. */
.rev-nombre {
    overflow: hidden;
    text-overflow: ellipsis;
}

/* "en 1 de 2 terminales": no es que le falte un dato, es que el producto no llego a
   todos los terminales o son dos productos distintos que se llaman igual. Por eso
   en el ambar de "ojo con esto" y no en el gris de lo que falta. */
.rev-actual.vacia {
    color: #96690f;
    font-style: normal;
}
</style>

<!-- Sin `scoped`: element-ui cuelga el desplegable del `body`. Acotado por
     `popper-class`, asi que no toca ningun otro `el-select`. -->
<style>
.rev-cat-desplegable .el-select-dropdown__item {
    display: flex;
    align-items: center;
    gap: 12px;
}

.rev-cat-desplegable .op-nombre {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rev-cat-desplegable .op-num {
    flex: 0 0 auto;
    min-width: 28px;
    text-align: right;
    font-size: 0.85em;
    font-variant-numeric: tabular-nums;
    color: #98a2ad;
}

.rev-cat-desplegable .el-select-dropdown__item.selected .op-num,
.rev-cat-desplegable .el-select-dropdown__item.hover .op-num {
    color: #4a5765;
}

.rev-cat-desplegable .el-select-group__title {
    font-size: 0.72em;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #98a2ad;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Categorias/ProductosSinCategoriaModal.vue